// import { useState, useEffect, useRef } from "react";
import { CssBaseline } from "@mui/material";
import { HashRouter } from "react-router-dom";
import { ThemeContextProvider } from "./context/ThemeContextProvider";
import { PageLayout } from "./ui/PageLayout";

const App = () => {
  return (
    <ThemeContextProvider>
      <HashRouter>
        <PageLayout>
          <>
            <CssBaseline />
          </>
        </PageLayout>
      </HashRouter>
    </ThemeContextProvider>
  );
};

export default App;
